import { render, staticRenderFns } from "./ModuleStructure.vue?vue&type=template&id=1d46ae48"
import script from "./ModuleStructure.vue?vue&type=script&lang=js"
export * from "./ModuleStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports